import axios from 'axios'
import { API_URL, LOCALSTORAGE_TOKEN_NAME } from '../api-config';

const axiosApi = axios.create({
  baseURL: API_URL
});

axiosApi.interceptors.request.use(config => {
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_NAME);
  if (token) {
    config.headers['x-token'] = token
  }

  return config
})

export default axiosApi